import { useAtom } from "jotai";
import { showAlertAtom, alertMessageAtom } from "../atoms/atoms";
import { Modal } from "react-bootstrap";

const GenericAlertModal = () => {

    const [message,] = useAtom(alertMessageAtom);
    const [show, setShow] = useAtom(showAlertAtom);

    return (
        <Modal show={show} onHide={() => setShow(false)}>
            <Modal.Header closeButton>
            </Modal.Header>
            <Modal.Body className="pb-5">
                
                <div className="text-center">
                {message}
                </div>
            </Modal.Body>

        </Modal>
    )

}

export default GenericAlertModal;